export default function VerifyCookie({onVerify}) {
    return (
        <div className="fixed bottom-0 flex w-full bg-pol-dark-800 text-sm z-[10000] py-4 shadow-[0px_-9px_16px_4px_rgba(94,84,127,0.3)]">
            <div className="container !px-0 lg:flex justify-between items-center">
                <p className="text-white text-justify mobile-content-p leading-[170%]">ما از کوکی های ضروری برای کارکرد سایت خود استفاده می کنیم. با کلیک روی &quot;می‌پذیرم&quot;، با استفاده از کوکی وب
                    سایت ما موافقت می کنید.</p>

                <div className="mobile-content-p mt-2 lg:mt-0 text-center">
                    <button
                        onClick={onVerify}
                        className="btn-main py-2.5 px-12"
                    >
                        می‌پذیرم
                    </button>
                </div>
            </div>
        </div>
    )
}
